export default __webpack_public_path__ + "static/media/shield-green.54816efa.svg";